/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FormTemplate } from './FormTemplate';
import {
    FormTemplateFromJSON,
    FormTemplateFromJSONTyped,
    FormTemplateToJSON,
    FormTemplateToJSONTyped,
} from './FormTemplate';

/**
 * 
 * @export
 * @interface ListFormTemplatesResponse
 */
export interface ListFormTemplatesResponse {
    /**
     * 
     * @type {Array<FormTemplate>}
     * @memberof ListFormTemplatesResponse
     */
    templates: Array<FormTemplate>;
}

/**
 * Check if a given object implements the ListFormTemplatesResponse interface.
 */
export function instanceOfListFormTemplatesResponse(value: object): value is ListFormTemplatesResponse {
    if (!('templates' in value) || value['templates'] === undefined) return false;
    return true;
}

export function ListFormTemplatesResponseFromJSON(json: any): ListFormTemplatesResponse {
    return ListFormTemplatesResponseFromJSONTyped(json, false);
}

export function ListFormTemplatesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListFormTemplatesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'templates': ((json['templates'] as Array<any>).map(FormTemplateFromJSON)),
    };
}

export function ListFormTemplatesResponseToJSON(json: any): ListFormTemplatesResponse {
    return ListFormTemplatesResponseToJSONTyped(json, false);
}

export function ListFormTemplatesResponseToJSONTyped(value?: ListFormTemplatesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templates': ((value['templates'] as Array<any>).map(FormTemplateToJSON)),
    };
}

